import { CodingRules, QuestionnaireRules as QuestionnaireRules_1_0_0 } from './QuestionnaireRecipes_1_0_0.js';
import { addRule, cloneRule, overwriteRule } from '../RecipeUtils.js';
/**
 * Values for custom extension to specify restrictions on answers
 */
export const QuestionnaireAnswerMinMaxValueRule = [
    {
        itemprop: 'valueInteger',
        itemtype: { type: 'string', regexp: /[0]|[-+]?[1-9][0-9]*/ },
        optional: true
    },
    {
        itemprop: 'valueDate',
        itemtype: {
            type: 'string',
            regexp: /(([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1]))?)?)|(^now$)/
        },
        optional: true
    },
    {
        itemprop: 'valueTime',
        itemtype: {
            type: 'string',
            regexp: /([01][0-9]|2[0-3]):[0-5][0-9]:([0-5][0-9]|60)(\.[0-9]+)?/
        },
        optional: true
    },
    {
        itemprop: 'valueString',
        optional: true
    },
    {
        itemprop: 'valueCoding',
        itemtype: { type: 'object', rules: CodingRules },
        optional: true
    }
];
/**
 * Custom extension to specify restrictions on answers
 */
export const AnswerRestrictionRule = [
    {
        itemprop: 'minValue',
        itemtype: { type: 'object', rules: QuestionnaireAnswerMinMaxValueRule },
        optional: true
    },
    {
        itemprop: 'minInclusive',
        itemtype: { type: 'boolean' },
        optional: true
    },
    {
        itemprop: 'maxValue',
        itemtype: { type: 'object', rules: QuestionnaireAnswerMinMaxValueRule },
        optional: true
    },
    {
        itemprop: 'maxInclusive',
        itemtype: { type: 'boolean' },
        optional: true
    }
];
/**
 * The rules to build a questionnaire based on FHIR
 */
export const QuestionnaireRules = cloneRule(QuestionnaireRules_1_0_0);
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'item',
    inheritFrom: 'Questionnaire_1_1_0.item',
    optional: true
});
addRule(QuestionnaireRules, 'item', {
    itemprop: 'answerRestriction',
    itemtype: { type: 'object', rules: AnswerRestrictionRule },
    optional: true
});
/**
 * Recipe for questionnaires based upon FHIR standard.
 *
 * @type {{name: string; rule: RecipeRule[]; $type$: string}}
 */
export const QuestionnaireRecipe = {
    $type$: 'Recipe',
    name: 'Questionnaire_1_1_0',
    rule: QuestionnaireRules
};
const QuestionnaireRecipes = [QuestionnaireRecipe];
export default QuestionnaireRecipes;
//# sourceMappingURL=QuestionnaireRecipes_1_1_0.js.map